import React from "react";
import {
  Button,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  DrawerHeader,
  DrawerBody,
  useDisclosure,
  Flex,
  Text,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuDivider,
} from "@chakra-ui/react";
import { GiHamburgerMenu } from "react-icons/gi";
import NavItem from "../NavItem";
import { AiOutlinePlusCircle } from "react-icons/ai";
import SubNavItem from "../SubNavItem";
import { HiOutlineDesktopComputer } from "react-icons/hi";
import { FaRegFileAlt, FaUsers } from "react-icons/fa";
import { FaArrowsDownToPeople } from "react-icons/fa6";
import { RiBankFill } from "react-icons/ri";
import { FotoUsuario } from "../FotoUsuario";
import {
  Permission,
  criancaFunc,
  dashboardFunc,
} from "../../../helpers/Funcionalidades";
import { useAuthProvider } from "../../../Context/AuthProvider";
import { ReactComponent as CensoInterativo } from "../../../assets/images/censo.svg";
import { ReactComponent as RelatorioPendencia } from "../../../assets/images/relatoriopendencia.svg";
import { ReactComponent as Filaprocessamento } from "../../../assets/images/filaprocessamento.svg";

export default function DrawerSidebar(props) {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const { roleKeycloack, logout, canChangeProfile, openProfileModal } = useAuthProvider();
  const btnRef = React.useRef();
  const navSize = "large";

  function mudarDePagina() {
    sessionStorage.clear();
    onClose();
  }

  const customCloseDrawer = () => {
    sessionStorage.clear();
    onClose();
  };

  return (
    <>
      <Button
        variant="link"
        color="white"
        as={GiHamburgerMenu}
        ref={btnRef}
        p={2}
        onClick={onOpen}
      />
      <Drawer
        isOpen={isOpen}
        placement="right"
        onClose={onClose}
        finalFocusRef={btnRef}
      >
        <DrawerOverlay />
        <DrawerContent backgroundColor="#006064">
          <DrawerCloseButton color={"white"} size={"lg"} />
          <DrawerHeader alignContent="center" mt={5}>
            <Flex alignItems={"center"}>
              <Menu>
                <MenuButton
                  as={Button}
                  rounded={"full"}
                  variant={"link"}
                  cursor={"pointer"}
                  minW={0}
                >
                  <FotoUsuario mobile={true} />
                  {/* <Avatar
                                        size={'md'}
                                        m={2}
                                        src={
                                            'https://images.unsplash.com/photo-1493666438817-866a91353ca9?ixlib=rb-0.3.5&q=80&fm=jpg&crop=faces&fit=crop&h=200&w=200&s=b616b2c5b373a80ffc9636ba24f7a4a9'
                                        }
                                    /> */}
                </MenuButton>
                <Text variant={"solid"} color={"white"} size={"sm"} mr={4}>
                  Fabiana Castro
                </Text>
                <MenuList>
                  <MenuItem
                    isDisabled={!canChangeProfile}
                    onClick={canChangeProfile ? openProfileModal : undefined}
                  >
                    Alterar Perfil / Órgão
                  </MenuItem>
                  <MenuDivider />
                  <MenuItem onClick={logout}>Sair</MenuItem>
                </MenuList>
              </Menu>
            </Flex>
          </DrawerHeader>

          <DrawerBody p="0">
            <Flex
              w={"100%"}
              flexDir="column"
              alignItems={navSize === "small" ? "center" : "flex-start"}
            >
              <Flex flexDir={"column"} onClick={customCloseDrawer} w={"100%"}>
                <NavItem
                  navSize={navSize}
                  href="/"
                  icon={HiOutlineDesktopComputer}
                  title="Dashboard"
                  active={props.categoria === "Dashboard"}
                />
                <Permission
                  roleKeycloack={roleKeycloack}
                  func={dashboardFunc.censoInterativo}
                >
                  <NavItem
                    navSize={navSize}
                    href="/dashboard"
                    icon={CensoInterativo}
                    title="Censo Interativo"
                    active={props.categoria === "Censo Interativo"}
                  />
                </Permission>
                <NavItem
                  navSize={navSize}
                  href="/servico-acolhimento"
                  icon={RiBankFill}
                  title="Serviços de Acolhimento"
                  active={props.categoria === "Serviços de Acolhimento"}
                />
                <NavItem
                  navSize={navSize}
                  href="/crianca"
                  icon={FaUsers}
                  title="Crianças e Adolescentes"
                  active={props.categoria === "Crianças e Adolescentes"}
                />
                <NavItem
                  navSize={navSize}
                  href="/visitas/lista"
                  icon={FaArrowsDownToPeople}
                  title="Agenda de Visitas"
                  active={props.entidade === "Visitas"}
                />
              </Flex>

              <NavItem
                href={"#"}
                navSize={navSize}
                icon={FaRegFileAlt}
                title="Relatórios"
                active={props.categoria === "Relatórios"}
              >
                <Flex flexDir={"column"} onClick={mudarDePagina}>
                  <Permission
                    roleKeycloack={roleKeycloack}
                    func={dashboardFunc.relatorioPendenciasExportar}
                  >
                    <SubNavItem
                      navSize={navSize}
                      icon={RelatorioPendencia}
                      href="/relatorios-pendencia/lista"
                      title="Relatório de Pendências"
                      active={props.entidade === "Relatório de Pendências"}
                    />
                  </Permission>

                  <Permission
                    roleKeycloack={roleKeycloack}
                    func={dashboardFunc.abaRelatorioCriancaGeral}
                  >
                    <SubNavItem
                      navSize={navSize}
                      icon={RelatorioPendencia}
                      href="/relatorios-crianca-adolescente/lista"
                      title="Relatório de Crianças e Adolescentes"
                      active={
                        props.entidade ===
                        "Relatório de Crianças e Adolescentes"
                      }
                    />
                  </Permission>

                  <SubNavItem
                    navSize={navSize}
                    icon={RelatorioPendencia}
                    href="/relatorios-servico-acolhimento/lista"
                    title="Relatório de Serviço de Acolhimento"
                    active={
                      props.entidade === "Relatório de Serviço de Acolhimento"
                    }
                  />
                </Flex>
              </NavItem>

              <Permission
                roleKeycloack={roleKeycloack}
                func={dashboardFunc.filaProcessamentoConsultar}
              >
                <NavItem
                  navSize={navSize}
                  href="/fila-processamento"
                  icon={Filaprocessamento}
                  title="Fila de Processamento"
                  active={props.entidade === "Fila de Processamento"}
                />
              </Permission>

              <Permission
                roleKeycloack={roleKeycloack}
                func={criancaFunc.visualizarTudo}
              >
                <NavItem
                  href={"#"}
                  navSize={navSize}
                  icon={AiOutlinePlusCircle}
                  title="Cadastros"
                  isOpen={props.categoria === "Cadastros"}
                >
                  <Flex flexDir={"column"} onClick={mudarDePagina}>
                    {/* <SubNavItem navSize={navSize} href="/tipo-servico-acolhimento/lista" title="Tipo de Serviço de Acolhimento" active={props.entidade === "Tipo de Serviço de Acolhimento"} /> */}
                    <SubNavItem
                      navSize={navSize}
                      href="/situacao-juridica/lista"
                      title="Situação Jurídica"
                      active={props.entidade === "Situação Jurídica"}
                    />
                    <SubNavItem
                      navSize={navSize}
                      href="/motivo-situacao/lista"
                      title="Motivo de Situação"
                      active={props.entidade === "Motivo de Situação"}
                    />
                    <SubNavItem
                      navSize={navSize}
                      href="/doenca/lista"
                      title="Doença"
                      active={props.entidade === "Doenças"}
                    />
                    <SubNavItem
                      navSize={navSize}
                      href="/perfil-acesso/lista"
                      title="Perfis de acesso"
                      active={props.entidade === "Perfis de Acesso"}
                    />
                  </Flex>
                </NavItem>
              </Permission>
            </Flex>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
}
